import { render, staticRenderFns } from "./PresentationView.vue?vue&type=template&id=60fceda6&scoped=true&"
import script from "./PresentationView.vue?vue&type=script&lang=js&"
export * from "./PresentationView.vue?vue&type=script&lang=js&"
import style0 from "./PresentationView.vue?vue&type=style&index=0&id=60fceda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fceda6",
  null
  
)

export default component.exports